export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
export const SET_WINDOW_SCROLL = 'SET_WINDOW_SCROLL';